import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { ArrowToggle } from './ArrowToggle';
import { LinkModel } from '../../models/globals';
import { useTouchableDropdown } from '../../hooks/useTouchableDropdown';

interface SubMenuProps {
    category: LinkModel;
    subCategories: LinkModel[];
}

const SubMenu: React.FC<SubMenuProps> = ({ category, subCategories }) => {
    const { menu, dropdown } = useTouchableDropdown();

    if (!category.name) return null;

    return (
        <Dropdown
            data-testid={`${category.name.toLowerCase().replace(/ /g, '-')}-nav-dropdown`}
            drop="right"
            id={`${category.name.toLowerCase().replace(/ /g, '-')}-nav-dropdown`}
            focusFirstItemOnShow="keyboard"
            {...dropdown}
        >
            <Dropdown.Toggle
                as={ArrowToggle}
                data-testid={`${category.name.toLowerCase().replace(/ /g, '-')}-toggle`}
                direction="right"
                id={`${category.name.toLowerCase().replace(/ /g, '-')}-toggle`}
            >
                <span className="menu-border-bottom">{category.name}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu
                data-testid={`${category.name.toLowerCase().replace(/ /g, '-')}-menu`}
                renderOnMount
                {...menu}
            >
                <Dropdown.Item
                    active={false}
                    data-testid={category.name}
                    disabled={!dropdown.show} // required to support keyboard navigation with arrows, see itemSelector in getNextFocusedChild in react-overlays/esm/Dropdown.js
                    href={category.url}
                >
                    <span className="menu-border-bottom">{`All ${category.name}`}</span>
                </Dropdown.Item>

                <Dropdown.Divider />

                {subCategories.map(({ name, url }) => (
                    <Dropdown.Item
                        active={false}
                        data-testid={name}
                        disabled={!dropdown.show} // required to support keyboard navigation with arrows, see itemSelector in getNextFocusedChild in react-overlays/esm/Dropdown.js
                        href={url}
                        key={name}
                    >
                        <span className="menu-border-bottom">{name}</span>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export { SubMenu, SubMenuProps };
